<template>
    <div class="prelative">
        <!-- LOADER -->
        <preloader :display="loading" class="preloader" />

        <div v-if="corporation == 0">
            {{ $l10n.__('Compte non synchronisé') }}.
            {{ $l10n.__('Veuillez ré-essayer dans quelques instants') }}...
        </div>
        <div v-else>
            <div v-if="customer.deleted === true">
                <span class="label label-danger">{{ $l10n.__('Compte Sellsy supprimé') }}</span>
            </div>
            <div v-if="maintenance">
                <p>CORPID #{{ customer.saasCorpId }}</p>
                <span class="label label-danger">{{ $l10n.__('Maintenance en cours') }}</span>
            </div>
            <div v-else>
                <table
                    class="table no-shadow table-condensed table-info wordbreak table-layout-fixed table-noborder"
                >
                    <tbody>
                        <tr>
                            <th>CORPID #{{ customer.saasCorpId }}</th>
                        </tr>
                        <tr v-if="customer.sendEthicAccountId">
                            <th>{{ 'Marketing ID' }}</th>
                            <td align="right">{{ `#${customer.sendEthicAccountId}` }}</td>
                        </tr>
                        <tr>
                            <th>
                                {{ $l10n.__('État du compte') }}
                            </th>
                            <td v-if="customer.locked === false" align="right">
                                <span
                                    :class="
                                        'thirdlabel labelCorp-' +
                                        customer.levelReadable +
                                        '-bg semibold mr-0'
                                    "
                                >
                                    {{ customer.levelReadable }}
                                </span>
                            </td>
                            <td v-else align="right">
                                <span :class="'thirdlabel labelCorp-blocked-bg semibold mr-0'">
                                    {{ $l10n.__('bloqué') }}
                                </span>
                            </td>
                        </tr>
                        <tr
                            v-if="
                                customer.locked === false &&
                                (customer.levelReadable === 'trial' ||
                                    customer.levelReadable === 'basic')
                            "
                        >
                            <th>
                                {{ $l10n.__('Trial') }}
                            </th>
                            <td class="pointer" align="right" @click="editTrial">
                                <span v-if="customer.levelReadable === 'trial'">
                                    {{ $filters.saasDateFormatted(customer.trialEndDate) }}
                                </span>
                                <span v-else>{{ $l10n.__('Non') }}</span>
                            </td>
                        </tr>
                        <tr v-if="customer.locked === false && customer.levelReadable === 'trial'">
                            <th>
                                {{ $l10n.__('Imports illimités') }}
                            </th>
                            <td align="right">
                                <span
                                    v-if="customerSettings.hasImportUnlimited"
                                    class="fright semibold spanLabel spanLabel-green"
                                    :class="{ pointer: canToggleImportLimited }"
                                    @click="toggleImportLimited(false)"
                                >
                                    {{ $l10n.__('Oui') }}
                                </span>
                                <span
                                    v-else
                                    class="fright semibold spanLabel spanLabel-red"
                                    :class="{ pointer: canToggleImportLimited }"
                                    @click="toggleImportLimited(true)"
                                >
                                    {{ $l10n.__('Non') }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                {{ $l10n.__('Plan') }}
                            </th>
                            <td align="right">
                                <span
                                    v-if="null !== billingSettings.pricingPlanCode"
                                    class="spanLabel spanLabel-lightgrey semibold capitalize"
                                >
                                    {{
                                        $filters.capitalize(
                                            $filters.lowerCase(billingSettings.pricingPlanCode),
                                        )
                                    }}
                                </span>
                                <span v-else>
                                    {{ $l10n.__('N/C') }}
                                </span>
                            </td>
                        </tr>
                        <tr v-if="customer.levelReadable === 'gold'">
                            <td colspan="2">
                                <table class="table table-noborder">
                                    <tbody>
                                        <tr>
                                            <td class="py-1 px-0 wp-5">
                                                <span class="semibold">{{
                                                    $l10n.__('Date de début service')
                                                }}</span>
                                                <br />
                                                <div>
                                                    {{
                                                        $filters.saasDateFormatted(
                                                            billingSettings.serviceStartDate,
                                                        )
                                                    }}
                                                </div>
                                            </td>
                                            <td class="py-1 px-0 wp-5 aright">
                                                <span class="semibold">
                                                    {{ $l10n.__('Date de fin service') }}
                                                </span>
                                                <br />
                                                <div>
                                                    {{
                                                        $filters.saasDateFormatted(
                                                            billingSettings.serviceEndDate,
                                                        )
                                                    }}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <span class="semibold">{{ $l10n.__('Tarifs appliqués') }}</span>
                            </td>
                            <td class="aright">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="'rev.' + billingSettings.pricingVersionRevision"
                                    placement="right"
                                >
                                    <span>v.{{ billingSettings.pricingVersion }}</span>
                                </el-tooltip>

                                <span
                                    v-if="
                                        billingSettings.pricingVersion === 4 &&
                                        customer.levelReadable === 'trial' &&
                                        !billingSettings.stripeSubscriptionSchedule &&
                                        !billingSettings.stripeSubscriptionId
                                    "
                                    class="spanLabel spanLabel-lightgrey semibold pointer"
                                    @click="switchPricingVersion(3)"
                                >
                                    => v.3 ?
                                </span>
                                <span
                                    v-if="
                                        billingSettings.pricingVersion !== 4 &&
                                        customer.levelReadable === 'trial' &&
                                        !billingSettings.stripeSubscriptionSchedule &&
                                        !billingSettings.stripeSubscriptionId
                                    "
                                    class="spanLabel spanLabel-lightgrey semibold pointer"
                                    @click="switchPricingVersion(4)"
                                >
                                    => v.4 ?
                                </span>
                                <span
                                    v-if="
                                        isPricingVersion5Enabled &&
                                        billingSettings.pricingVersion < 5 &&
                                        billingSettings.billingProvider === 'chargebee' &&
                                        customer.levelReadable === 'trial' &&
                                        !billingSettings.stripeSubscriptionSchedule &&
                                        !billingSettings.stripeSubscriptionId
                                    "
                                    class="spanLabel spanLabel-lightgrey semibold pointer"
                                    @click="switchPricingVersion(5)"
                                >
                                    => v.5 ?
                                </span>
                            </td>
                        </tr>

                        <tr v-if="isChargebeeEnabled">
                            <td>
                                <span class="typographies-heading-h4">
                                    {{ $l10n.__('Service de facturation') }}
                                </span>
                            </td>
                            <td class="aright">
                                <span
                                    v-if="
                                        !customer.deleted &&
                                        ['trial', 'basic'].includes(customer.levelReadable) &&
                                        !billingSettings.stripeSubscriptionSchedule &&
                                        !(
                                            billingSettings.billingProvider === 'chargebee' &&
                                            billingSettings.pricingVersion > 4
                                        )
                                    "
                                    class="spanLabel spanLabel-lightgrey typographies-paragraph-caps-small-semibold pointer"
                                    @click="
                                        switchBillingProvider(
                                            billingSettings.billingProvider === 'stripe'
                                                ? 'chargebee'
                                                : 'stripe',
                                        )
                                    "
                                >
                                    {{ $filters.capitalize(billingSettings.billingProvider) }}
                                </span>
                                <span v-else>
                                    {{ $filters.capitalize(billingSettings.billingProvider) }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span class="semibold">Self Service</span>
                            </td>
                            <td class="aright">
                                <span
                                    v-if="billingSettings.selfService"
                                    class="fright semibold spanLabel spanLabel-green"
                                    :class="{ pointer: canToggleSelfService }"
                                    @click="toggleSelfService(false)"
                                >
                                    {{ $l10n.__('Oui') }}
                                </span>
                                <span
                                    v-else
                                    class="fright semibold spanLabel spanLabel-red"
                                    :class="{ pointer: canToggleSelfService }"
                                    @click="toggleSelfService(true)"
                                >
                                    {{ $l10n.__('Non') }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span class="semibold">{{ $l10n.__('Facturation SAAS') }}</span>
                            </td>
                            <td class="aright">
                                <span
                                    v-if="billingSettings.saasBillingEnabled"
                                    class="fright semibold spanLabel spanLabel-green"
                                    :class="{ pointer: canToggleSaasBilling }"
                                    @click="toggleSaasBilling(false)"
                                >
                                    {{ $l10n.__('Oui') }}
                                </span>
                                <span
                                    v-else
                                    class="fright semibold spanLabel spanLabel-red"
                                    :class="{ pointer: canToggleSaasBilling }"
                                    @click="toggleSaasBilling(true)"
                                >
                                    {{ $l10n.__('Non') }}
                                </span>
                            </td>
                        </tr>

                        <tr v-if="billingSettings.vatIdentificationNumber">
                            <td>
                                <span class="semibold">{{ $l10n.__('TVA intra') }}</span>
                            </td>
                            <td class="aright">
                                <span>
                                    {{
                                        $filters.upperCase(billingSettings.vatIdentificationNumber)
                                    }}
                                </span>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <span class="semibold">{{ $l10n.__('Nb staffs autorisé') }}</span>
                            </td>
                            <td class="aright">
                                <span
                                    :class="{ pointer: canEditAvailableStaffNumber }"
                                    @click="toggleEditAvailableStaffNumber()"
                                >
                                    {{ availableStaffNumber }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span class="semibold">{{ $l10n.__('MRR') }}</span>
                            </td>
                            <td class="aright">
                                <span v-if="billingSettings.mrr">
                                    {{ formatAmount(billingSettings.mrr / 100, true) }}
                                </span>
                                <span v-else>{{ $l10n.__('N/C') }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span class="semibold">{{ $l10n.__('ARR') }}</span>
                            </td>
                            <td class="aright">
                                <span v-if="billingSettings.arr">
                                    {{ formatAmount(billingSettings.arr / 100, true) }}
                                </span>
                                <span v-else>{{ $l10n.__('N/C') }}</span>
                            </td>
                        </tr>
                        <tr v-if="editAvailableStaffNumber">
                            <td colspan="2" class="aright">
                                <input
                                    v-model="availableStaffNumberTmp"
                                    type="number"
                                    class="h-4 mr-2"
                                    min="1"
                                    max="100"
                                />
                                <CompassButton
                                    :label="$filters.capitalize($t.__('common.actions.cancel'))"
                                    type="secondary"
                                    size="small"
                                    class="pointer"
                                    @click="toggleEditAvailableStaffNumber()"
                                />
                                <CompassButton
                                    :label="$filters.capitalize($t.__('common.actions.validate'))"
                                    type="primary"
                                    size="small"
                                    :disabled="availableStaffNumber === availableStaffNumberTmp"
                                    @click="recordAvailableStaffNumber()"
                                />
                            </td>
                        </tr>

                        <tr v-if="thirdPayerId">
                            <td>
                                <span class="semibold">{{ $l10n.__('Tiers payeur') }}</span>
                            </td>
                            <td class="aright">
                                <CompassLink :label="thirdPayerName" :link="thirdPayerUrl" />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span class="semibold">UTM</span>
                            </td>
                            <td class="aright">
                                <CompassButton
                                    v-if="canEditUtm"
                                    :label="
                                        $filters.capitalize(
                                            $t.__('sellsyadmin.CorporationData_v3.edit'),
                                        )
                                    "
                                    type="tertiary"
                                    size="small"
                                    @click="editUtm"
                                />
                            </td>
                        </tr>
                        <tr v-if="utm && utm.source">
                            <td colspan="2">
                                <table
                                    class="table no-shadow table-condensed table-info wordbreak table-layout-fixed table-noborder"
                                >
                                    <tbody>
                                        <tr>
                                            <th class="p-0 pl-3">source</th>
                                            <td class="p-0 aright">{{ utm.source }}</td>
                                        </tr>
                                        <tr>
                                            <th class="p-0 pl-3">medium</th>
                                            <td class="p-0 aright">{{ utm.medium }}</td>
                                        </tr>
                                        <tr>
                                            <th class="p-0 pl-3">campaign</th>
                                            <td class="p-0 aright">{{ utm.campaign }}</td>
                                        </tr>
                                        <tr v-if="utm.source === 'affiliation'">
                                            <th class="p-0 pl-3">parrain</th>
                                            <td class="p-0 aright">{{ utm.parrainname }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <ul class="overview-actions mt-2 bt-1 pt-1">
                    <li v-if="canUnlinkCorp" class="mt-2">
                        <CompassButton
                            :label="$t.__('sellsyadmin.CorporationData_v3.unlink_account')"
                            type="secondary"
                            @click="unlinkCorporation"
                        />
                    </li>
                    <li v-if="canLinkThirdPayer" class="mt-2">
                        <CompassButton
                            :label="$t.__('sellsyadmin.CorporationData_v3.link_third_payer')"
                            type="secondary"
                            @click="linkThirdPayer"
                        />
                    </li>
                    <li v-if="canUnlinkThirdPayer" class="mt-2">
                        <CompassButton
                            :label="$t.__('sellsyadmin.CorporationData_v3.unlink_third_payer')"
                            type="secondary"
                            @click="unlinkThirdPayer"
                        />
                    </li>
                    <li v-if="canSynchronizeContactFromCorporation" class="mt-2">
                        <CompassButton
                            :label="$t.__('sellsyadmin.CorporationData_v3.synchronize_contact')"
                            type="secondary"
                            @click="synchronizeContacts"
                        />
                    </li>
                    <li v-if="canBlockAccount" class="mt-2">
                        <CompassButton
                            :label="$t.__('sellsyadmin.CorporationData_v3.block_account')"
                            type="secondary"
                            @click="lockCustomer"
                        />
                    </li>
                    <li v-if="canUnblockAccount" class="mt-2">
                        <CompassButton
                            :label="$t.__('sellsyadmin.CorporationData_v3.unblock_account')"
                            type="secondary"
                            @click="unlockCustomer"
                        />
                    </li>
                    <template
                        v-if="
                            customer.levelReadable === 'gold' &&
                            canChurnCustomerPermission &&
                            !isChargebeeProvider
                        "
                    >
                        <li class="mt-2">
                            <CompassButton
                                :label="$t.__('sellsyadmin.CorporationData_v3.churn')"
                                type="secondary"
                                :disabled="churnActionLoading"
                                @click="doChurnAction"
                            />
                        </li>
                    </template>
                    <template
                        v-if="
                            !customer.deleted &&
                            billingSettings.salesCartEnabled &&
                            !isChargebeeProvider
                        "
                    >
                        <li class="mt-2">
                            <CompassButton
                                :label="$t.__('sellsyadmin.CorporationData_v3.create_cart')"
                                type="secondary"
                                @click="hrefButton(newCartUrl)"
                            />
                        </li>
                        <template
                            v-if="
                                customer.billingSettings.pricingVersion < 4 &&
                                customer.levelReadable === 'basic' &&
                                !isChargebeeProvider
                            "
                        >
                            <li class="mt-2">
                                <CompassButton
                                    :label="$t.__('sellsyadmin.CorporationData_v3.create_v4_cart')"
                                    type="secondary"
                                    @click="hrefButton(newCartV4Url)"
                                />
                            </li>
                        </template>
                        <template v-if="isGold && !isChargebeeProvider">
                            <li v-if="customer.billingSettings.pricingVersion === 3" class="mt-2">
                                <CompassButton
                                    :label="
                                        $t.__('sellsyadmin.CorporationData_v3.create_v3_renew_cart')
                                    "
                                    type="secondary"
                                    @click="hrefButton(renewV3Url)"
                                />
                            </li>
                            <li class="mt-2">
                                <CompassButton
                                    :label="
                                        $t.__('sellsyadmin.CorporationData_v3.create_v4_renew_cart')
                                    "
                                    type="secondary"
                                    @click="hrefButton(renewV4Url)"
                                />
                            </li>
                        </template>
                    </template>
                    <template v-if="!customer.deleted && billingSettings.chargebeeCustomerId">
                        <li class="mt-2">
                            <CompassButton
                                :label="$t.__('sellsyadmin.CorporationData_v3.access_bubble')"
                                type="secondary"
                                @click="goToBubble"
                            />
                        </li>
                        <li class="mt-2">
                            <CompassButton
                                :label="$t.__('sellsyadmin.CorporationData_v3.view_invoices')"
                                type="secondary"
                                @click="openChargebeeInvoicingDialog"
                            />
                        </li>
                        <template v-if="canShowCancelTacitRenewal">
                            <li class="mt-2">
                                <CompassButton
                                    :label="
                                        $t.__(
                                            'sellsyadmin.CorporationData_v3.cancel_contract_terms',
                                        )
                                    "
                                    type="secondary"
                                    @click="handleCancelSubscription"
                                />
                            </li>
                        </template>
                    </template>
                    <template v-if="customer.levelReadable === 'trial'">
                        <li class="mt-2">
                            <CompassButton
                                :label="trialBannerButtonLabel"
                                type="secondary"
                                @click="toggleTrialBanner"
                            />
                        </li>
                    </template>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
// Store
import SAMMixins from 'mixins/subscription/SAMMixins';
import WidgetStore from 'mixins/sellsyaccountmanager/store/widgetStoreMixins';
import WidgetMixins from 'mixins/sellsyaccountmanager/widgetMixins';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import Feature from 'Services/Feature';
import { goToUrl } from 'vueDir/helpers';
import Env from 'Services/Env';
import { fetchSubscription } from 'api/chargebee/chargebeeService';
export default {
    components: {
        Preloader,
    },
    mixins: [SAMMixins, WidgetStore, WidgetMixins],
    props: {
        corporation: {
            type: Number,
            required: true,
        },
        thirdPayerId: {
            type: String,
            required: false,
        },
        thirdPayerName: {
            type: String,
            required: false,
        },
        canEditUtm: {
            type: Boolean,
            default: false,
        },
        canBlockUnblockAccount: {
            type: Boolean,
            default: false,
        },
        canManageThirdPayer: {
            type: Boolean,
            default: false,
        },
        canUnlinkCorp: {
            type: Boolean,
            default: false,
        },
        canDisableSalesCart: {
            type: Boolean,
            default: false,
        },
        canDisableSaasBilling: {
            type: Boolean,
            default: false,
        },
        canDisableTrialImportLimit: {
            type: Boolean,
            default: false,
        },
        canSynchronizeDataOnThird: {
            type: Boolean,
            default: false,
        },
        canChurnCustomer: {
            type: Boolean,
            default: false,
        },
        displayTrialBanner: {
            type: Boolean,
            default: true,
        },
        thirdId: {
            type: String,
            required: true,
        },
        maintenance: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            availableStaffNumber: 0,
            availableStaffNumberTmp: 0,
            editAvailableStaffNumber: false,
            utm: false,
            churnActionLoading: false,
            contractTerm: null,
        };
    },

    computed: {
        isChargebeeProvider() {
            return this.billingSettings.billingProvider === 'chargebee';
        },
        sellsyRM: function () {
            return 'http://sellsyrm.sellsy.typhon.net/corp/view/' + this.customer.saasCorpId;
        },
        newCartUrl: function () {
            if (this.customer.billingSettings.pricingVersion === 4) {
                if (this.isGold) {
                    return this.$router.resolve({
                        name: 'sam.v4.upsell.cart.form',
                        params: {
                            corpId: this.customer.saasCorpId,
                            thirdId: this.customer.saasThirdId,
                            customerId: this.customer.id,
                            id: 'new',
                        },
                    }).href;
                } else {
                    return this.$router.resolve({
                        name: 'sam.v4.cart.form',
                        params: {
                            thirdId: this.customer.saasThirdId,
                            customerId: this.customer.id,
                            id: 'new',
                        },
                    }).href;
                }
            } else {
                return (
                    '/sam-cart/new/' +
                    this.customer.saasCorpId +
                    (this.customer.levelReadable === 'gold' ? '?context=upsale' : '')
                );
            }
        },
        newCartV4Url() {
            return this.$router.resolve({
                name: 'sam.v4.cart.form',
                params: {
                    thirdId: this.customer.saasThirdId,
                    customerId: this.customer.id,
                    id: 'new',
                },
            }).href;
        },
        renewV3Url() {
            return `/sam-cart/new/${this.customer.saasCorpId}?context=renew`;
        },
        renewV4Url() {
            return this.$router.resolve({
                name: 'sam.v4.sale.renew.cart.form',
                params: {
                    corpId: this.customer.saasCorpId,
                    thirdId: this.customer.saasThirdId,
                    customerId: this.customer.id,
                    id: 'new',
                },
            }).href;
        },
        canEditAvailableStaffNumber: function () {
            return this.customer.levelReadable === 'trial';
        },
        thirdPayerUrl: function () {
            return '/?_f=third&thirdid=' + this.thirdPayerId;
        },
        canLinkThirdPayer: function () {
            return (
                !this.customer.deleted &&
                this.canManageThirdPayer &&
                !this.thirdPayerId &&
                !this.isChargebeeProvider
            );
        },
        canUnlinkThirdPayer: function () {
            return this.canManageThirdPayer && this.thirdPayerId && !this.isChargebeeProvider;
        },
        canBlockAccount: function () {
            return (
                !this.customer.deleted &&
                this.canBlockUnblockAccount &&
                this.customer.levelReadable === 'gold' &&
                this.customer.locked === false
            );
        },
        canUnblockAccount: function () {
            return (
                !this.customer.deleted &&
                this.canBlockUnblockAccount &&
                this.customer.levelReadable === 'gold' &&
                this.customer.locked === true
            );
        },
        canToggleSelfService() {
            return (
                this.canDisableSaasBilling &&
                this.billingSettings.saasBillingEnabled &&
                this.billingSettings.salesCartEnabled
            );
        },
        canToggleSaasBilling() {
            return this.canDisableSaasBilling;
        },
        canToggleImportLimited() {
            return this.canDisableTrialImportLimit;
        },
        isPricingVersion5Enabled() {
            return Feature.isEnabled('sam-pricing-v5');
        },
        isChargebeeEnabled() {
            return Feature.isEnabled('chargebee');
        },
        canSynchronizeContactFromCorporation() {
            return this.canSynchronizeDataOnThird;
        },
        canChurnCustomerPermission: function () {
            return this.canChurnCustomer;
        },
        canCancelTacitRenewal() {
            return this.isGold && this.isChargebeeProvider && this.canChurnCustomerPermission;
        },
        canShowCancelTacitRenewal() {
            return this.canCancelTacitRenewal && 'renew' === this.contractTerm?.action_at_term_end;
        },
        isGold() {
            return this.customer.levelReadable === 'gold';
        },
        trialBannerButtonLabel() {
            return this.displayTrialBanner
                ? Loc.g('Cacher la bannière trial')
                : Loc.g('Afficher la bannière trial');
        },
    },

    /**
     * this.corporation can be equal to 0 if account is not synchronized into SAM platform
     * Calling SAM API with an ID equal to 0 is useless
     */
    created() {
        if (Number.isInteger(this.corporation) && this.corporation > 0) {
            Promise.all([
                this.getCustomer(this.corporation),
                this.getBillingSettings(this.corporation),
                this.getCustomerSettings(this.corporation),
                this.getUtm(this.corporation),
            ])
                .then(this.handleResolvedPromises, this.handlerRejectedPromises)
                .finally(() => {
                    this.availableStaffNumber = this.billingSettings.availableStaffNumber;
                    this.loading = false;
                });
        }
    },
    methods: {
        goToBubble() {
            const url = `${Env.get('chargebee').bubbleUrl}/customer_details?customer_id=${
                this.billingSettings.chargebeeCustomerId
            }&page=overview`;
            window.open(url, '_blank');
        },
        openChargebeeInvoicingDialog() {
            window.ChargebeeGlobal.openCbPortalSection(
                'BILLING_HISTORY',
                {},
                this.billingSettings.chargebeeCustomerId,
            );
        },
        editTrial() {
            window.Corporation.changeAccountTrial(this.customer.saasCorpId);
        },
        async handleCancelSubscription() {
            try {
                await window.ChargebeeGlobal.initChargebeeScript();
                const cbPortal = await window.ChargebeeGlobal.initCbPortal(
                    this.billingSettings.chargebeeCustomerId,
                );
                cbPortal.open(
                    {
                        close: async () => {
                            await this.fetchChargebeeSubscriptionDatas();
                            window.ChargebeeGlobal.clearChargebeeScript();
                        },
                    },
                    {
                        sectionType: 'sub_cancel',
                        params: {
                            subscriptionId: this.billingSettings.chargebeeSubscriptionId,
                        },
                    },
                );
            } catch (e) {
                console.error(e);
            }
        },
        async handleResolvedPromises(promisesResults) {
            this.setCustomer(promisesResults[0]);
            this.setBillingSettings(promisesResults[1]);
            this.setCustomerSettings(promisesResults[2]);
            this.utm = promisesResults[3];
            if (this.canCancelTacitRenewal) {
                await this.fetchChargebeeSubscriptionDatas();
            }
        },
        fetchChargebeeSubscriptionDatas() {
            return fetchSubscription(false, this.billingSettings.chargebeeSubscriptionId).then(
                (subscription) => {
                    this.contractTerm = subscription.data.subscription?.contract_term;
                },
            );
        },
        handlerRejectedPromises() {
            console.log(arguments);
        },

        unlinkCorporation() {
            SellsyAdmin.unlinkCorp(this.corporation);
        },

        toggleTrialBanner() {
            SellsyAdmin.toggleTrialBanner(this.corporation, this.thirdId, this.displayTrialBanner);
        },

        switchPricingVersion(version) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.$ajax.put(
                    '/rest/corporation/' + this.corporation + '/pricing-version/' + version,
                    {},
                    {},
                    (response) => {
                        if (response.error) {
                            throw response;
                        }
                        resolve(response);
                    },
                );
            })
                .then((response) => {
                    Push.success(
                        Loc.g('Modification réussie'),
                        Loc.g('Modification version tarifaire'),
                    );
                    Utils.reload();
                })
                .catch((response) => {
                    Push.error(response.error.message, Loc.g('Modification version tarifaire'));
                    this.loading = false;
                });
        },

        switchBillingProvider(provider) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.$ajax.put(
                    '/rest/sellsy-account-manager/corporation/' +
                        this.corporation +
                        '/billing-provider/' +
                        provider,
                    {},
                    {},
                    (response) => {
                        if (response.error) {
                            throw response;
                        }
                        resolve(response);
                    },
                );
            })
                .then(() => {
                    this.$pushToast({
                        type: 'success',
                        icon: true,
                        text: this.$l10n.__('Modification du fournisseur de facturation réussie'),
                    });
                    Utils.reload();
                })
                .catch((error) => {
                    this.$pushToast({
                        type: 'error',
                        icon: true,
                        text: error.error.message,
                    });
                    this.loading = false;
                });
        },

        toggleEditAvailableStaffNumber() {
            if (!this.canEditAvailableStaffNumber) return;
            this.availableStaffNumberTmp = this.availableStaffNumber;
            this.editAvailableStaffNumber = !this.editAvailableStaffNumber;
        },

        toggleSelfService(enable) {
            if (!this.canToggleSelfService) return;
            return this.recordBillingSettings(this.corporation, {
                selfService: enable,
            }).then((billingSettings) => {
                this.setBillingSettings(billingSettings);
            });
        },
        toggleSaasBilling(enable) {
            if (!this.canToggleSaasBilling) return;
            return this.recordBillingSettings(this.corporation, {
                saasBillingEnabled: enable,
                salesCartEnabled: enable, // enable sales cart till this feature is not fully managed
            }).then((billingSettings) => {
                this.setBillingSettings(billingSettings);
            });
        },
        toggleImportLimited(enable) {
            if (!this.canToggleImportLimited) return;
            return this.recordCustomerSettings(this.corporation, {
                hasImportUnlimited: enable,
            }).then((customerSettings) => {
                this.setCustomerSettings(customerSettings);
            });
        },
        recordAvailableStaffNumber() {
            this.$confirm(
                'Tous les comptes collaborateurs en excès seront bloqués',
                'Modification du nombre de collaborateurs autorisés',
                {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: 'Confirmer',
                    cancelButtonText: 'Annuler',
                    type: 'warning',
                },
            )
                .then(() => {
                    return this.updateAvailableStaffNumber(
                        this.corporation,
                        this.availableStaffNumberTmp,
                    )
                        .then((result) => {
                            Push.success(
                                'Mise à jour effectuée, les accès collaborateurs en excès ont été bloqués',
                                'Nombre de collaborateurs',
                            );
                            this.availableStaffNumber = result.availableStaffNumber;
                            this.editAvailableStaffNumber = false;
                        })
                        .catch((e) => {
                            Push.error(e, 'Nombre de collaborateurs');
                        });
                })
                .catch(() => {
                    this.editAvailableStaffNumber = false;
                });
        },

        editUtm() {
            window.Corporation.editUTM(this.corporation);
        },

        linkThirdPayer() {
            window.SellsyAdmin.linkThirdPayer(this.customer.saasThirdId);
        },

        unlinkThirdPayer() {
            window.SellsyAdmin.unlinkThirdPayer(this.customer.saasThirdId);
        },

        lockCustomer() {
            window.Corporation.toggleBlocked(
                this.customer.saasThirdId,
                this.customer.saasCorpId,
                'Y',
            );
        },

        unlockCustomer() {
            window.Corporation.toggleBlocked(
                this.customer.saasThirdId,
                this.customer.saasCorpId,
                'N',
            );
        },

        synchronizeContacts() {
            window.SellsyAdmin.synchronizeContacts(
                this.customer.saasThirdId,
                this.customer.saasCorpId,
            );
        },
        doChurnAction() {
            this.churnActionLoading = true;
            window.SellsyJS.WebServiceCaller.put(
                `/rest/sellsy-account-manager/corporation/${this.customer.saasCorpId}/churn`,
                {},
                {},
                (res) => {
                    this.churnActionLoading = false;
                    this.$router.go();
                },
                (err) => {
                    this.churnActionLoading = false;
                },
            );
        },
        hrefButton(url) {
            return goToUrl(url);
        },
    },
};
</script>
